import { render } from "./SectionPoster.vue?vue&type=template&id=3e195dd4"
import script from "./SectionPoster.vue?vue&type=script&lang=js"
export * from "./SectionPoster.vue?vue&type=script&lang=js"

import "./SectionPoster.vue?vue&type=style&index=0&id=3e195dd4&lang=scss"

import exportComponent from "/Users/lucas/Web/_loco/theadccawards/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__